'use client'

import { useMemo } from 'react'

import { TErrorPageHandledCode, useErrorCode } from './useErrorCode'

export type TErrorCodeToTranslations = Record<
	TErrorPageHandledCode,
	{ title: string; description: string }
>

interface ErrorDetailsProps {
	errorCodeToTranslations: TErrorCodeToTranslations
	customTitle?: string
	customDescription?: string
}

export const ErrorDetails = ({
	errorCodeToTranslations,
	customTitle,
	customDescription,
}: ErrorDetailsProps) => {
	const code = useErrorCode()

	const { title, description } = useMemo(() => {
		if (customTitle && customDescription) {
			return {
				title: customTitle,
				description: customDescription,
			}
		}

		return (
			errorCodeToTranslations[code as keyof typeof errorCodeToTranslations] || {
				title: 'Error',
				description: 'Something went wrong.',
			}
		)
	}, [code, errorCodeToTranslations, customTitle, customDescription])

	return (
		<>
			<h2 className="type-heading-2 text-center">{title}</h2>
			<p className="type-body-medium text-center text-dark-grey">
				{description}
			</p>
		</>
	)
}
